import { DEFAULT_MAX_ATTEMPTS } from "../../../../shared/delivery/max-attempts";
import { type FailedDeliveryState } from "./state";

export const initialState: FailedDeliveryState = {
  isSubmitting: false,
  submitError: "",
  submitErrorCode: "",
  addresses: [],
  isLoadingAddresses: false,
  zones: [],
  isLoadingZones: false,
  maxAttempts: DEFAULT_MAX_ATTEMPTS,
};
